import axios from "axios";
import { BASE_URL } from "../../_constants/urlConstants";
import { delay, getUUID } from "../../_utils/generalUtils";
import raiseError from "../raiseError";
import qs from "qs";
import { QMS } from "../../_constants/actionConstants";

const fakeCmtStages = [
  {
    cmtStageId: 1,
    divisionId: 1,
    title: "Stage A.1",
    description: "",
    defaultOwnerTeamId: null,
  },
  {
    cmtStageId: 2,
    divisionId: 1,
    title: "Stage A.2",
    description: "",
    defaultOwnerTeamId: null,
  },
  {
    cmtStageId: 3,
    divisionId: 1,
    title: "Stage B.1",
    description: "",
    defaultOwnerTeamId: null,
  },
];

const logError = (e) => console.error("ProDMS/QMS: Request failed with error:", e);

const cmtStageActions = {
  add: (newCmtStageData) => async (dispatch) => {
    dispatch({ type: QMS.CMT_STAGE.ADD });
    const apiEndpoint = BASE_URL + "/api/qms/CmtStage";
    try {
      const res = await axios.post(apiEndpoint, newCmtStageData);
      dispatch({
        type: QMS.CMT_STAGE.ADD_FULFILLED,
        divisionId: newCmtStageData.divisionId,
        cmtStages: res.data,
      });
    } catch (e) {
      dispatch({ type: QMS.CMT_STAGE.ADD_REJECTED });
      logError(e);
    }
  },
  update: (cmtStageData) => async (dispatch) => {
    dispatch({ type: QMS.CMT_STAGE.UPDATE });
    const apiEndpoint = BASE_URL + "/api/qms/CmtStage";
    try {
      const res = await axios.put(apiEndpoint, cmtStageData);
      dispatch({
        type: QMS.CMT_STAGE.UPDATE_FULFILLED,
        divisionId: cmtStageData.divisionId,
        cmtStages: res.data,
      });
    } catch (e) {
      dispatch({ type: QMS.CMT_STAGE.UPDATE_REJECTED });
      logError(e);
    }
  },
  remove: (cmtStageId, divisionId) => async (dispatch) => {
    dispatch({ type: QMS.CMT_STAGE.REMOVE });
    const apiEndpoint = BASE_URL + "/api/qms/CmtStage/" + cmtStageId;
    try {
      const res = await axios.delete(apiEndpoint);
      dispatch({ type: QMS.CMT_STAGE.REMOVE_FULFILLED, divisionId, cmtStages: res.data });
    } catch (e) {
      dispatch({ type: QMS.CMT_STAGE.REMOVE_REJECTED });
      logError(e);
    }
  },
  removeRange: (cmtStageIds, divisionId) => async (dispatch) => {
    dispatch({ type: QMS.CMT_STAGE.REMOVE });
    const apiEndpoint_delete = `${BASE_URL}/api/qms/CmtStage`;
    try {
      const delRes = await axios.delete(apiEndpoint_delete, {
        params: { ids: cmtStageIds || [] },
        paramsSerializer: (params) => qs.stringify(params),
      });
      if (delRes.data.message) {
        dispatch({ type: QMS.CMT_STAGE.REMOVE_REJECTED });
        // Show alert
        alert(delRes.data.message);
      } else {
        const apiEndpoint_getAll = BASE_URL + "/api/qms/CmtStage/List/" + divisionId;
        const res = await axios.get(apiEndpoint_getAll);
        dispatch({
          type: QMS.CMT_STAGE.REMOVE_FULFILLED,
          divisionId,
          cmtStages: res.data,
        });
      }
    } catch (e) {
      dispatch({ type: QMS.CMT_STAGE.REMOVE_REJECTED });
      logError(e);
    }
  },
  getAllFake: (divisionId) => async (dispatch) => {
    dispatch({ type: QMS.CMT_STAGE.FETCH_ALL });

    delay(250);
    dispatch({
      type: QMS.CMT_STAGE.FETCH_ALL_FULFILLED,
      divisionId,
      cmtStages: fakeCmtStages,
    });
  },
  getAll: (divisionId) => async (dispatch) => {
    dispatch({ type: QMS.CMT_STAGE.FETCH_ALL });
    const apiEndpoint = BASE_URL + "/api/qms/CmtStage/List/" + divisionId;
    try {
      const res = await axios.get(apiEndpoint);
      dispatch({
        type: QMS.CMT_STAGE.FETCH_ALL_FULFILLED,
        divisionId,
        cmtStages: res.data,
      });
    } catch (e) {
      dispatch({ type: QMS.CMT_STAGE.FETCH_ALL_REJECTED });
      logError(e);
    }
  },
};

export default cmtStageActions;
